export const SET_UPGRADE_LINK = 'SET_UPGRADE_LINK';
